import { render, staticRenderFns } from "./puppy-for-sale-container.vue?vue&type=template&id=48edf2dc&scoped=true&lang=pug"
import script from "./puppy-for-sale-container.js?vue&type=script&lang=js&external"
export * from "./puppy-for-sale-container.js?vue&type=script&lang=js&external"
import style0 from "./puppy-for-sale-container.vue?vue&type=style&index=0&id=48edf2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edf2dc",
  null
  
)

export default component.exports